import { useEffect, useState } from "react";

import { ReduxState } from "Store/rootReducer";
import { useSelector } from "react-redux";

interface PriceStatus {
  priceIsChanging: boolean;
  setPriceIsChanging: (value: boolean) => void;
  priceIsLoading: boolean;
  setPriceIsLoading: (value: boolean) => void;
}

export const usePriceStatus = (): PriceStatus => {
  const {
    advice: { advicePriceCalculationResults },
  } = useSelector((state: ReduxState) => state);
  const [priceIsChanging, setPriceIsChanging] = useState(false);
  const [priceIsLoading, setPriceIsLoading] = useState(false);

  useEffect(() => {
    if (advicePriceCalculationResults.isLoading === false) {
      setPriceIsLoading(false);
    }
  }, [advicePriceCalculationResults]);

  return {
    priceIsChanging,
    setPriceIsChanging,
    priceIsLoading,
    setPriceIsLoading,
  };
};
